import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DynamicQuestionService } from '../services/dynamic-question.service';
import { Screening } from '../Models/Screening';
import { Referrer } from '../Models/Enums/Referrer';
import { Router } from '@angular/router';
import { MilitaryBranch } from '../Models/Enums/MilitaryBranch';
import { EmployeeLookup } from '../Models/EmployeeLookup';
import { IntegrationService } from '../services/integration.service';

@Component({
  selector: 'app-question-viewer-single',
  templateUrl: './question-viewer-single.component.html',
  styleUrls: ['./question-viewer-single.component.less']
})
export class QuestionViewerSingleComponent implements OnInit {

  @ViewChild('redirectForm') redirectForm:ElementRef;
  @ViewChild('isTaxCreditInput') isTaxCreditInput:ElementRef;
  @ViewChild('isCreditInput') isCreditInput:ElementRef;
  @ViewChild('taxBreakGuidInput') taxBreakGuidInput:ElementRef;
  @ViewChild('optedOutInput') optedOutInput:ElementRef;
  @ViewChild('returnCodeInput') returnCodeInput:ElementRef;
  
  StateArray : string[] = ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN',
   'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
  public militaryBranchValues : string[] = ['Army', 'Navy', 'Marines', 'Air Force', 'Coast Guard'];
  notQualified : boolean = false;
  qualified : boolean = false;
  showButtons : boolean = true;
  check : string = "";
  showQuestions: boolean = true;
  returnUrl: string = "";
  showRedirect: boolean = false;
  isTaxCredit: boolean = false;
  taxBreakGuid: string= "";
  optedOut: boolean = false;
  returnCode: string="";
  
  constructor(public question : DynamicQuestionService, private router : Router, private changer: ChangeDetectorRef,
    private integration: IntegrationService) 
  {
    if(!question.screening) {
      question.screening = new Screening();
      question.screening.demographics = new EmployeeLookup();
    }
    this.question.flow = [
      {order: 0, show : () => {return true}, receivedInteraction: false},
      {order: 1, show : () => {return true}, receivedInteraction: false},
      {order: 2, show : () => {return true}, receivedInteraction: false},
      {order: 3, show : () => {return true}, receivedInteraction: false},
      {order: 4, show : () => {return true}, receivedInteraction: false},
      {order: 5, show : () => {return this.question.screening.tanf || false}, receivedInteraction: false},
      {order: 6, show : () => {return this.question.screening.snap || false}, receivedInteraction: false},
      {order: 7, show : () => {return this.question.screening.ssi || false}, receivedInteraction: false},
      {order: 8, show : () => {return this.question.screening.unemploymentComp || false}, receivedInteraction: false},
      {order: 9, show : () => {return this.question.screening.militaryService || false}, receivedInteraction: false},
      {order: 10, show : () => {return this.question.screening.militaryService || false}, receivedInteraction: false},
      {order: 11, show : () => {return this.question.screening.militaryService || false}, receivedInteraction: false}
    ];
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  select(id : string) {
    this.question.screening[id] = !this.question.screening[id];
    let el = document.getElementById(id);
    //if the user selects NA, all other options should be set to false. 
    if(id == 'benefitNA') {
      this.question.screening.tanf = false;
      this.question.screening.snap = false;
      this.question.screening.ssi = false;
      document.getElementById('tanf').classList.remove('checked');
      document.getElementById('snap').classList.remove('checked');
      document.getElementById('ssi').classList.remove('checked');
    } else {
      //if the user has selected benefitNA then clicks an option, set it to false.
      this.question.screening.benefitNA = false;
      document.getElementById('benefitNA').classList.remove('checked');
    }
    
    if(this.question.screening[id]){
      el.classList.add('checked');
    } else {
      el.classList.remove('checked');
    }

    this.continualEligibility();
    
    console.log(this.question.screening[id]);
  }

  continualEligibility()
  {
    if((this.question.screening.tanf == false || this.question.screening.tanf == undefined) &&
         (this.question.screening.snap == false || this.question.screening.snap == undefined) &&
         (this.question.screening.ssi == false || this.question.screening.ssi == undefined) &&
         (this.question.screening.unemploymentComp == false || this.question.screening.unemploymentComp == undefined) &&
         (this.question.screening.militaryService == false || this.question.screening.militaryService == undefined) &&
         (this.question.screening.referral == 3 || this.question.screening.referral == undefined))
        {
          this.notQualified = true;
          this.qualified=false;
        } else {
          var scrn=this.question.screening;
          this.qualified=true;
          this.notQualified=false;
        }
  }

  save()
  {
    var scrn=this.question.screening;
    let component=this;
    this.question.SaveScreeningToDatabase().subscribe(e => {
      scrn.integrationProfile.employeeId = e.integrationProfile.employeeId;
      if (component.question.screening.integrationProfile.returnUrl!=null)
      {
        if (component.question.screening.integrationProfile.returnUrl!="https://screen.synergipartners.com/redirect")
        {
          component.isTaxCreditInput.nativeElement.value=false;
          component.isCreditInput.nativeElement.value=false;
          component.taxBreakGuidInput.nativeElement.value=this.question.screening.integrationProfile.taxBreakGUID;
          component.optedOutInput.nativeElement.value=false;
          component.returnCodeInput.nativeElement.value="";
          component.redirectForm.nativeElement.action=this.question.screening.integrationProfile.returnUrl;
          component.redirectForm.nativeElement.submit();
        }
      }
    });
  }

  optout() : void {
    if (this.integration.integrationProfile.returnUrl!=null)
    {
      this.isTaxCreditInput.nativeElement.value=false;
      this.isCreditInput.nativeElement.value=false;
      this.taxBreakGuidInput.nativeElement.value=this.integration.integrationProfile.taxBreakGUID;
      this.optedOutInput.nativeElement.value=true;
      this.returnCodeInput.nativeElement.value="";
      this.redirectForm.nativeElement.action=this.integration.integrationProfile.returnUrl;
      this.redirectForm.nativeElement.submit();
    }
  }

  updateProgress(screen : Screening, e : boolean, button:string) {
    if (button=="uComp")
    {
      screen.unemploymentComp=e;
    }

    if (button=="uMilitary")
    {
      screen.militaryService=e;
    }

    if (button=="uFelon")
    {
      screen.felon=e;
    }

    if (button=="ssi60")
    {
      screen.ssi60Days=e;
    }

    if (button=="militaryDischarge")
    {
      screen.militaryDischarge=e;
    }

    if (button=="militaryCompensation")
    {
      screen.militaryCompensation=e;
    }

    if(this.question.order==1)screen.unemploymentComp = e;
    if(this.question.order==2)screen.militaryService = e;
    if(this.question.order==3)screen.felon = e;
    if(this.question.order==7)screen.ssi60Days = e;
    if(this.question.order==10)screen.militaryDischarge = e;
    if(this.question.order==11)screen.militaryCompensation = e;


    this.continualEligibility();


    console.log(this.question.screening);
  }

  setInputRange(range : number) {
    let elems : HTMLInputElement[] = [
      <HTMLInputElement>document.getElementById('tanf1'),
      <HTMLInputElement>document.getElementById('tanf2'),
      <HTMLInputElement>document.getElementById('tanf3'),
      <HTMLInputElement>document.getElementById('snap1'),
      <HTMLInputElement>document.getElementById('snap2'),
      <HTMLInputElement>document.getElementById('snap3'),
      <HTMLInputElement>document.getElementById('unemp1'),
      <HTMLInputElement>document.getElementById('unemp2'),
      <HTMLInputElement>document.getElementById('unemp3'),
    ]
    if(range < 4) {
      //turn off all inputs during selection to prevent multi-select
      elems.slice(0,3).forEach((e) => {
        //e.classList.remove('checked-small');
      })
      //tanf inputs
      this.question.screening.tanfReceivedTimeFrame = range;
      elems[range].classList.add('checked');
      this.continualEligibility();
      return;
    }
    if(range < 7) {
      elems.slice(3,6).forEach((e) => {
        e.checked = false;
      })
      //snap inputs
      this.question.screening.snapReceivedTimeFrame = range;
      elems[range].classList.add('checked-small');
      this.continualEligibility();
      return;
    }
    if(range < 10) {
      elems.slice(6,9).forEach((e) => {
        e.checked = false;
      })
      //unemployment inputs
      this.question.screening.unemployedTimeFrame = range;
      elems[range].classList.add('checked-small');
      this.continualEligibility();
      return;
    }
    this.continualEligibility();
  }

  setReferral(ref : number) {
    console.log('setting referral')
    //manually deselect checkboxes to ensure the displayed behavior is what's expected
    let elements = [
      { id: 0, ref: document.getElementById('refVA') },
      { id: 1, ref: document.getElementById('refTTW') },
      { id: 2, ref: document.getElementById('refVR') },
      { id: 3, ref: document.getElementById('refNA') }
    ];
    elements.forEach((e) => 
    {
      let a = <HTMLInputElement>e.ref;
      a.checked = false;
      a.classList.remove("checked");
    })
    if(this.question.screening.referral == ref) {
      this.continualEligibility();
      return;
    } else {
      this.question.screening.referral = ref;
      let b = <HTMLInputElement>elements.filter(e => e.id == ref)[0].ref;
      b.checked = true;
      b.classList.add("checked");
      this.continualEligibility();
      console.log('refferal', this.question.screening);
    }
  }

  setAgeGroup(ref : number) {
    console.log('setting age')
    //manually deselect checkboxes to ensure the displayed behavior is what's expected
    let elements = [
      { id: 0, ref: document.getElementById('noAgeGroup') },
      { id: 1, ref: document.getElementById('under18') },
      { id: 2, ref: document.getElementById('under40') }
    ];
    elements.forEach((e) => 
    {
      let a = <HTMLInputElement>e.ref;
      a.checked = false;
      a.classList.remove("checked");
    })
    if(this.question.screening.ageGroup == ref) {
      this.continualEligibility();
      return;
    } else {
      this.question.screening.ageGroup = ref;
      let b = <HTMLInputElement>elements.filter(e => e.id == ref)[0].ref;
      b.checked = true;
      b.classList.add("checked");
      this.continualEligibility();
      console.log('ageGroup', this.question.screening);
    }
  }

  isSelectedEnum(n : number) {
    console.log('running enum comparer')
    if(this.question.screening.referral == n) return true
    else return false;
  }

  back() : void {
    console.log(this.question.screening);
    while(this.question.order > 0) {
      try {
        if(this.question.flow[this.question.order-1].show() == false) {
          // console.log('autoincrementing past unshown questions')
          this.question.order--;
        } else {
          break;
        }
      } catch (error) {
        break;        
      }
    }
    if(this.question.order > 0) {
      this.question.order--;
    } else {
      this.router.navigateByUrl('lookup')
    }
  }

  return() : void {
    this.save();
  }

  continue() : void {
    // console.log(this.question.screening);
    //if the next question(s) shouldn't be shown, increment past
    // while(this.question.order < this.question.flow.length) {
    //   try {
    //     if(this.question.flow[this.question.order+1].show() == false) {
    //       // console.log('autoincrementing past unshown questions');
    //       this.question.order++;
    //     } else {
    //       break;
    //     }
    //   } catch (error) {
    //     break;        
    //   }
    // }
    // if(this.question.order < this.question.flow.length-1) {
    //   this.question.order++;
    // } else {
      //if they answered no to the top level questions, show the dnq section
      if((this.question.screening.tanf == false || this.question.screening.tanf == undefined) &&
         (this.question.screening.snap == false || this.question.screening.snap == undefined) &&
         (this.question.screening.ssi == false || this.question.screening.ssi == undefined) &&
         (this.question.screening.unemploymentComp == false || this.question.screening.unemploymentComp == undefined) &&
         (this.question.screening.militaryService == false || this.question.screening.militaryService == undefined) &&
         (this.question.screening.referral == 3 || this.question.screening.referral == undefined))
        {
          //if they DNQ, save it off to the DB and show the DNQ page
          this.question.SaveScreeningToDatabase().subscribe(e => {
            console.log('saved DNQ record');
          });
          this.notQualified = true;
          this.showButtons = false;
          this.showQuestions = false;
        } else {
          var scrn=this.question.screening;
          // persist the screening to cosmos and continue to esign.
          this.question.SaveScreeningToDatabase().subscribe(res => {
            scrn.integrationProfile.employeeId = res.integrationProfile.employeeId;
            this.router.navigateByUrl('esign');
          })
        }
    //}
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/question-viewer-single/question-viewer-single.component.ts